export const SIMPLE_FIELD_TYPE = {
  INPUT: "INPUT",
  SELECT: "SELECT",
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  DATE_PICKER: "DATE_PICKER",
};

export const FIELD_MASK = {
  PHONE: "PHONE",
  HUF: "HUF",
};

export const DATE_VALIDATION = {
  PAST: "PAST",
  FUTURE: "FUTURE",
};

export const RESTRICTION_TYPE = {
  PUBLIC: "PUBLIC",
  SECURED: "SECURED",
  RESTRICTED: "RESTRICTED",
};

export const FLOW_POSITION = {
  LOGIN: "LOGIN",
  SIGNING_3RD: "SIGNING_3RD", // comnica
  SIGNING_SMS: "SIGNING_SMS", // sms
  INTRO: "INTRO",
  EMAIL_CONFIRM: "EMAIL_CONFIRM",
  FLOW: "FLOW",
  OVERVIEW: "OVERVIEW",
  ONBOARDING: "ONBOARDING",
  SUMMARY: "SUMMARY",
  SCORING: "SCORING",
  HIGH_RISK_KYC: "HIGH_RISK_KYC",
  KYC_PREPARATION: "KYC_PREPARATION",
  KYC_CHOOSE: "KYC_CHOOSE",
  KYC_WAITING: "KYC_WAITING",
  CONTRACT_CHECK: "CONTRACT_CHECK",
  SIGN_PREPARATION: "SIGN_PREPARATION",
  SIGN_CHOOSE: "SIGN_CHOOSE",
  SIGN_WAITING: "SIGN_WAITING",
  UNDER_REVIEW: "UNDER_REVIEW",
  OFFLINE_UNDER_REVIEW: "OFFLINE_UNDER_REVIEW",
  RESULT: "RESULT",
  OFFLINE_RESULT: "OFFLINE_RESULT",
  PURCHASE_RESULT: "PURCHASE_RESULT",
  FIRST_PAYMENT: "PAYMENT",
  PAYMENT_STARTED: "PAYMENT_STARTED",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
};

export const FLOW_QUESTION_FIELD_TYPE = {
  SIMPLE_FIELD: "SIMPLE_FIELD",
  STATEMENT_PROMPT: "STATEMENT_PROMPT",
  DOCUMENT_PROMPT: "DOCUMENT_PROMPT",
  READONLY_FIELD: "READONLY_FIELD",
  PSD2_FIELD: "PSD2_FIELD",
  SPECIAL_FIELD: "SPECIAL_FIELD",
};

export const SPECIAL_FIELD_TYPE = {
  PSD2: "PSD2",
  KYC: "KYC",
  EMAIL_CONFIRM: "EMAIL_CONFIRM",
  REVIEW_TEXT: "REVIEW_TEXT",
  REVIEW_SCORE: "REVIEW_SCORE",
  REVIEW_NPS: "REVIEW_NPS",
  REVIEW_VIDEO: "REVIEW_VIDEO",
  CUSTOMER_FIRST_NAME: "CUSTOMER_FIRST_NAME",
  CUSTOMER_LAST_NAME: "CUSTOMER_LAST_NAME",
  MOTHERS_NAME: "MOTHERS_NAME",
  BIRTH_PLACE: "BIRTH_PLACE",
  BIRTH_DATE: "BIRTH_DATE",
  POST_CODE: "POST_CODE",
  CITY: "CITY",
  STREET: "STREET",
  HOUSE_NUMBER: "HOUSE_NUMBER",
  IDENTIFF_KYC: "IDENTIFF_KYC",
  CEGADATAPI_EMPLOYER: "CEGADATAPI_EMPLOYER",
  CEGADATAPI_ENTREPRENEUR: "CEGADATAPI_ENTREPRENEUR",
};

export const CUSTOMER_SPECIAL_FIELDS = [
  SPECIAL_FIELD_TYPE.CUSTOMER_FIRST_NAME,
  SPECIAL_FIELD_TYPE.CUSTOMER_LAST_NAME,
  SPECIAL_FIELD_TYPE.MOTHERS_NAME,
  SPECIAL_FIELD_TYPE.BIRTH_PLACE,
  SPECIAL_FIELD_TYPE.BIRTH_DATE,
  SPECIAL_FIELD_TYPE.POST_CODE,
  SPECIAL_FIELD_TYPE.CITY,
  SPECIAL_FIELD_TYPE.STREET,
  SPECIAL_FIELD_TYPE.HOUSE_NUMBER,
  SPECIAL_FIELD_TYPE.REVIEW_VIDEO,
];

export const APPLICATION_TEMPLATE = {
  TRIPLE_OFFER_BOTTOM: "TRIPLE_OFFER_BOTTOM",
  OFFER_ACCEPTANCE_MODAL: "OFFER_ACCEPTANCE_MODAL",
  APPLICATION_INTRO_BOTTOM: "APPLICATION_INTRO_BOTTOM",
  KYC_PREP: "KYC_PREP",
  SIGN_PREP: "SIGN_PREP",
  APPLICATION_IS_CLOSED: "APPLICATION_IS_CLOSED",
  APPLICATION_SUCCESS: "APPLICATION_SUCCESS",
  APPLICATION_FAILURE: "APPLICATION_FAILURE",
  BNPL_FLOW_INTRO: "BNPL_FLOW_INTRO",
  BNPL_BAD_PATH: "BNPL_BAD_PATH",
};

export const LOGIN_STATUS = {
  ENUM: {
    REGISTRATION_INCOMPLETE: "REGISTRATION_INCOMPLETE",
    PASSWORD_CHANGE_REQUIRED: "PASSWORD_CHANGE_REQUIRED",
    LOGIN_OK: "LOGIN_OK",
  },
};

export const CALL_ME_BACK_TYPE = {
  CBR_BTN: "CBR_BTN",
  OFFLINE_OFFER: "OFFLINE_OFFER",
  NO_OFFER: "NO_OFFER",
  EXIT_INTENT: "EXIT_INTENT",
};

export const STATEMENT_PROMPT_TYPE = {
  DOCUMENT: "DOCUMENT",
  LINK: "LINK",
};

export const UI_CONFIGS = {
  NAME_ON_REG: "name_on_reg",
  PSD2_MOCK_ENABLED: "psd2_mock_enabled",
  PSD2_SYNC_UI_URL: "psd2_sync_ui_url",
  PSD2_BANK_API_URL: "psd2_bank_api_url",
  RECAPTCHA_ENABLED: "recaptcha_enabled",
  RECAPTCHA_SITE_KEY: "recaptcha_site_key",
};

export const SIGNATURE_PROCESS_STATUS = {
  NOT_READY: "NOT_READY",
  READY: "READY",
  WITHDRAWN: "WITHDRAWN",
  EXPIRED: "EXPIRED",
  ERROR_FOUND: "ERROR_FOUND",
};

export const CORRECTION_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  WITHDRAWN: "WITHDRAWN",
  COMPLETED: "COMPLETED",
  CLOSED: "CLOSED:",
  CANCELLED: "CANCELLED",
};

export const CONDITIONAL_FIELD_OPERATOR = {
  ENUM: {
    AND: "AND",
    OR: "OR",
  },
};

export const TODO_TYPE = {
  ENUM: {
    CORRECTION: "CORRECTION",
    SIGNATURE: "SIGNATURE",
  },
  ICON: {
    CORRECTION: "file-invoice",
    SIGNATURE: "file-signature",
  },
  NAME: {
    CORRECTION: "af:my_todos.card.correction.type",
    SIGNATURE: "af:my_todos.card.signature.type",
  },
  TITLE: {
    CORRECTION: "af:my_todos.card.correction.title",
    SIGNATURE: "af:my_todos.card.signature.title",
  },
  BUTTON: {
    CORRECTION: "af:my_todos.card.correction.open",
    SIGNATURE: "af:my_todos.card.signature.open",
  },
  STATUS: {
    CORRECTION: {
      IN_PROGRESS: "af:my_todos.card.correction.status.in_progress",
      WITHDRAWN: "af:my_todos.card.correction.status.withdrawn",
      COMPLETED: "af:my_todos.card.correction.status.completed",
      CLOSED: "af:my_todos.card.correction.status.closed",
      CANCELLED: "af:my_todos.card.correction.status.cancelled",
    },
    SIGNATURE: {
      IN_PROGRESS: "af:my_todos.card.signature.status.waiting",
      WAITING: "af:my_todos.card.signature.status.accepted",
      ACCEPTED: "af:my_todos.card.signature.status.in_progress",
      SIGNED: "af:my_todos.card.signature.status.signed",
      CLOSED: "af:my_todos.card.signature.status.closed",
    },
  },
  OUTCOME: {
    CORRECTION: {
      SUCCESSFUL: "af:my_todos.card.correction.outcome.successful",
      UNSUCCESSFUL: "af:my_todos.card.correction.outcome.unsuccessful",
    },
    SIGNATURE: {
      ERROR_FOUND: "af:my_todos.card.correction.outcome.error_found",
      CANCEL: "af:my_todos.card.correction.outcome.cancel",
      WITHDRAWN: "af:my_todos.card.correction.outcome.withdrawn",
      EXPIRED: "af:my_todos.card.correction.outcome.expired",
    },
  },
};

export const BNPL_APPLICATION_STATUS = {
  /** Initial */
  CREATED: "CREATED",

  /** After logging in */
  INITIAL: "INITIAL",

  /** After the overview page */
  STARTED: "STARTED",

  /** Cancelled before review */
  CANCELLED: "CANCELLED",

  /** During scoring / manual override */
  UNDER_REVIEW: "UNDER_REVIEW",

  /** After scoring, awaiting signature */
  APPROVED: "APPROVED",

  /** Documents signed */
  SIGNED: "SIGNED",

  /** First payment completed */
  COMPLETED: "COMPLETED",

  /** Scoring negative result */
  DENIED: "DENIED",

  /** Cancelled after review */
  INTERRUPTED: "INTERRUPTED",

  /** During scoring evaluation */
  SCORING: "SCORING",
};

export const ClOSEABLE_BNPL_APPLICATION_STATUSES = [
  BNPL_APPLICATION_STATUS.INITIAL,
  BNPL_APPLICATION_STATUS.APPROVED,
  BNPL_APPLICATION_STATUS.UNDER_REVIEW,
  BNPL_APPLICATION_STATUS.STARTED,
];

export const PRELIM_TYPE = {
  KEY: "preliminaryAssessmentType",
  PSD2: "PSD2",
  MANUAL: "MANUAL",
};

export const PRELIM_FIXED_STEPS = {
  AMOUNT_AND_TERM: 0,
  TYPE_SELECT: 1,
};

export const PRELIM_PSD2_FIXED_STEPS = {
  SYNC: 2,
};

export const PSD2_FIELD_SOURCE = {
  PRELIM: "PRELIM",
  BNPL_APPLICATION: "BNPL",
  CORRECTION: "CORRECTION",
};

export const PSD2_OUTCOME = {
  NEEDS_ACCOUNT_REGISTRATION: "NEEDS_ACCOUNT_REGISTRATION",
  NEEDS_BANK_SELECT: "NEEDS_BANK_SELECT",
  CAN_START_A8_SYNC: "CAN_START_A8_SYNC",
};

export const PSD2_SYNC_OUTCOME = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export const PSD2_SYNC_START_OUTCOME = {
  NEEDS_ACCOUNT_REGISTRATION: "NEEDS_ACCOUNT_REGISTRATION",
  CAN_START_A8_SYNC: "CAN_START_A8_SYNC",
  NEEDS_BANK_SELECT: "NEEDS_BANK_SELECT",
};
export const SCORE_DECISION = {
  ENUM: {
    APPROVED: "APPROVED",
    REJECT: "REJECT",
    MANUAL: "MANUAL",
    MANUALLY_APPROVED: "MANUALLY_APPROVED",
    MANUALLY_REJECTED: "MANUALLY_REJECTED",
  },
  TOKEN: {
    APPROVED: "af:score.decision_type.approved",
    REJECT: "af:score.decision_type.reject",
    MANUAL: "af:score.decision_type.manual",
    MANUALLY_APPROVED: "af:score.decision_type.manually_approved",
    MANUALLY_REJECTED: "af:score.decision_type.manually_rejected",
  },
};

export const EVENTS = {
  FLOW_VALIDATION: "FLOW_VALIDATION",
  TOKENS_LOADED: "TOKENS_LOADED",
  STATUS_UPDATED: "STATUS_UPDATED",
  OPEN_CALL_ME_BACK_MODAL: "OPEN_CALL_ME_BACK_MODAL",
  OPEN_BASKET_MODAL: "OPEN_BASKET_MODAL",
  PRELIM_TYPE_CHANGED: "PRELIM_TYPE_CHANGED",
};

export const DEAL_STATUS = {
  /** Initial */
  PREPARED: "PREPARED",

  /** The application flow is finished and the deal's first transaction is ready to be paid */
  READY: "READY",

  /** Cancelled during application phase */
  CANCELLED: "CANCELLED",

  /** Cancelled because a fallback application was created */
  CANCELLED_FALLBACK: "CANCELLED_FALLBACK",

  /** After application is completed */
  INITIAL_PAYMENT_COMPLETED: "INITIAL_PAYMENT_COMPLETED",

  /** After any (not initial) payment is received */
  ONGOING: "ONGOING",

  /** If any transaction is delayed */
  ONGOING_DELAYED: "ONGOING_DELAYED",

  /** All payments completed */
  COMPLETED: "COMPLETED",

  /** Cancelled after initial payment */
  INTERRUPTED: "INTERRUPTED",
};

/** Deal statuses in which a transaction pay button may be shown */
export const PAYABLE_DEAL_STATUSES = [
  DEAL_STATUS.READY,
  DEAL_STATUS.INITIAL_PAYMENT_COMPLETED,
  DEAL_STATUS.ONGOING,
  DEAL_STATUS.ONGOING_DELAYED,
];

export const LIMIT_POSITIONS = {
  LOGIN: "LOGIN",
  INTRO: "INTRO",
  DATA: "DATA",
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  PSD2_SYNC: "PSD2_SYNC",
  SCORING: "SCORING",
  RESULT: "RESULT",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
};

export const LIMIT_SOURCE = {
  APPLICATION: "APPLICATION",
  PROFILE: "PROFILE",
  EMAIL: "EMAIL",
  WEBSHOP: "WEBSHOP",
};

export const LIMIT_STATUS = {
  STARTED: "STARTED",
  CANCELLED: "CANCELLED",
  ACTIVE: "ACTIVE",
  DENIED: "DENIED",
  INTERRUPTED: "INTERRUPTED",
  EXPIRED: "EXPIRED",
};

export const SAFE_FLOW_POSITIONS = [
  FLOW_POSITION.PAYMENT_STARTED,
  FLOW_POSITION.COMPLETED,
  "REVIEW",
  BNPL_APPLICATION_STATUS.CANCELLED,
];

export const PSD2_TYPE = {
  A8: "A8",
  GO_CARDLESS: "GO_CARDLESS",
};

export const BNPL_INSTANCE_TYPE = {
  MERCHANT_FINANCE: "MERCHANT_FINANCE",
  FACTORING: "FACTORING",
};

export const REFERRAL_STATUS = {
  SIGNED_UP: "SIGNED_UP",
  STARTED: "STARTED",
  SUCCESSFUL: "SUCCESSFUL",
  PAID: "PAID",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export const REFERRAL_STATUS_TOKENS = {
  SIGNED_UP: "bnpl:referral.status.signed_up",
  STARTED: "bnpl:referral.status.started",
  SUCCESSFUL: "bnpl:referral.status.successful",
  PAID: "bnpl:referral.status.paid",
  REJECTED: "bnpl:referral.status.rejected",
  CANCELLED: "bnpl:referral.status.cancelled",
};

export const REFERRAL_CAMPAIGN_STATUS = {
  PREPARED: "PREPARED", // fel van paraméterezve egy jövőbeni kezdéssel
  RUNNING: "RUNNING", // elkezdődött és fut
  ENDED: "ENDED", // beállítotot lejárat szerint lejárt
  STOPPED: "STOPPED", // manuálisan le lett állítva
  PAID: "PAID", // kifizettt státusz lett jelölve
};

export const B2B_FLOW_STEPS = {
  LOGIN: "LOGIN",
  OVERVIEW: "OVERVIEW",
  INTRO: "INTRO",
  COMPANY_VALIDATE: "COMPANY_VALIDATE",
  B2B_EMAIL_CONFIRM: "B2B_EMAIL_CONFIRM",
  B2B_PSD2: "B2B_PSD2",
  B2B_KYC: "B2B_KYC",
  FLOW: "FLOW",
  SCORING: "SCORING",
  HIGH_RISK_KYC: "HIGH_RISK_KYC",
  COMPANY_AUTHORIZED: "COMPANY_AUTHORIZED",
  CONTRACT_CHECK: "CONTRACT_CHECK",
  SIGNING_SMS: "SIGNING_SMS",
  PAYMENT: "PAYMENT",
  PAYMENT_STARTED: "PAYMENT_STARTED",
  COMPLETED: "COMPLETED",
};

/**
 * Which flow is hosting an IdentiffKyc component. The KYC finishes by advancing its host, and the
 * customer limit igénylés does not walk the bnpl application store, so the component has to be told
 * where it lives.
 */
export const KYC_HOST_FLOW = Object.freeze({
  BNPL_APPLICATION: "BNPL_APPLICATION",
  CUSTOMER_LIMIT: "CUSTOMER_LIMIT",
});

export const B2B_KYC_SUB_STEP = {
  INTRO: "INTRO",
  CODE: "CODE",
  WAITING: "WAITING",
  RESULT: "RESULT",
  DATA_CHECK: "DATA_CHECK",
  OUTRO: "OUTRO",
};

export const KYC_SUB_STEP = {
  INTRO: "INTRO",
  CODE: "CODE",
  WAITING: "WAITING",
  RESULT: "RESULT",
  DATA_CHECK: "DATA_CHECK",
  OUTRO: "OUTRO",
};

export const KYC_STATUS = {
  CREATED: "CREATED",
  IN_PROGRESS: "IN_PROGRESS",
  MANUAL_REVIEW: "MANUAL_REVIEW",
  COMPLETED: "COMPLETED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  TERMINATED: "TERMINATED",
  CANCELLED: "CANCELLED",
};

export const KYC_INTERNAL_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  ACTIVE: "ACTIVE",
  SKIPPED: "SKIPPED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  REJECTED: "REJECTED",
};

export const KYC_PROGRESS_STEP = {
  OUTRO: "OUTRO",
};

export const BNPL_LIMIT_FLOW_POSITION = {
  LOGIN: "LOGIN",
  INTRO: "INTRO",
  DATA: "DATA",
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  PSD2_SYNC: "PSD2_SYNC",
  SCORING: "SCORING",
  RESULT: "RESULT",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
  MERCHANT_RESULT: "MERCHANT_RESULT",
};

export const BNPL_SEGMENT = {
  BUSINESS: "BUSINESS",
  CUSTOMER: "CUSTOMER",
};
